jQuery(document).ready(function($){
	/*$.ajax({
	  url: "http://www.roshfrans.com/wp-json/wp/v2/producto/",
	  context: document.body
	}).success(function(data) {
	  console.log(data)
	});*/
	if ( itr.current_page == "welcome" ){
		var Producto = Backbone.Model.extend({});
		var Productos = Backbone.Collection.extend({
			model: Producto
		});
		var ProductoView = Backbone.View.extend({
			el: '#modalProducto',
			initialize: function() {
    			this.template = _.template($('#productModalTemplate').html());
    			this.model.on("change", this.render, this);
  			},
  			render: function() {
    			var renderedContent = this.template({producto: this.model});
    			$(this.el).html(renderedContent);
    			$('.closeProductModal').on('click', function(event){
					event.preventDefault();
					console.log('click')
					$('#modalProducto').addClass('unfix');
					$('#modalProducto').removeClass('fixed');
				});
    			return this;
  			}
		});
		var currentProducto = new Producto();
		var productos = new Productos();
		var selectedProductoView = new ProductoView({
			model: currentProducto
		});
		var destacado1 = window.destacado1;
		var destacado2 = window.destacado2;
		var destacado3 = window.destacado3;
		var waitForProducts;
		var gotProductos = false;
		$.ajax({
	  		url: "http://www.roshfrans.com/wp-json/wp/v2/producto/",
	  		data: {
	  			'include': [destacado1, destacado2, destacado3] 
	  		},
	  		context: document.body
			}).success(function(data) {
	  			$.each(data, function(index, productoData){
	  				var producto = new Producto(productoData);
	  				productos.add(producto);
	  			});
	  			gotProductos = true;
		});
		$('.productoView').on('click', function(event){
			event.preventDefault();
			var getID = parseInt($(this).attr('href').split('-')[1]);
			waitForProducts = setInterval(function(){
				if( gotProductos === true ){
					clearInterval(waitForProducts);
					getSelectedProduct(getID);
				}
			},
			500)

		});
		
		function getSelectedProduct(getID){
			var selectedProduct = productos.findWhere({id: getID});
			currentProducto.set({
				name: selectedProduct.attributes.title.rendered,
				desc_es: selectedProduct.attributes.product_data.desc_es,
				hoja_de_seguridad: selectedProduct.attributes.product_data.hoja_de_seguridad,
				hoja_tecnica: selectedProduct.attributes.product_data.hoja_tecnica,
				image: selectedProduct.attributes.product_data.image,
				presentaciones: selectedProduct.attributes.product_data.presentaciones
			});
			$('#modalProducto').addClass('fixed');
			$('#modalProducto').removeClass('unfix');
		}
	};
});